import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../components/layout/loader/loader.component';
import { Router } from '@angular/router';

import { TableGuruComponent } from '../../components/table-guru/table-guru.component';
import { ClientFormComponent } from '../../components/client/client-form/client-form.component';

import { PageHeaderComponent } from '../../components/page-header/page-header.component';

@Component({
  selector: 'app-clients-index',
  standalone: true,
  imports: [
    CommonModule,
    LoaderComponent,
    TableGuruComponent,
    PageHeaderComponent
  ],
  templateUrl: './clients.component.html',
  styleUrl: './clients.component.scss'
})
export class ClientsIndexComponent {
  items: [] = [];
  private modalService = inject(NgbModal);
  reloadItems: boolean = false;
  buttonText: string = '<i class="bi bi-plus"></i> Toevoegen';

  editFormReference = ClientFormComponent;

  constructor(
  ) { }

  openModal(item: any) {
    let self = this;
    const modalRef = this.modalService.open(this.editFormReference, { size: 'lg' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.item = item;
    modalRef.result.then((result) => {
      self.reloadItems = true;
      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
  }
}
